<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list v-if="trendShow" row-key="AbstractId" ref="list" unit="加工单元" :expand-all-row="true" :page="page" :show-checkbox="true"
      :show-query="true" :query-params="params" @row-select="onRowClick" :get-data-func="api.list" urlHash="production/craftsmanship/unit">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <p>设备列表</p>
    <el-table class="subItem-table" :data="subList"  border>
      <el-table-column align="left" prop="EquipmentNo" label="设备编码"></el-table-column>
      <el-table-column align="left" prop="EquipmentName" label="设备名称" min-width="140px" show-overflow-tooltip></el-table-column>
      <el-table-column align="left" label="所属单元">
        <template slot-scope="{ row }">
          <span>{{ row.ProcessUnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="Workload" label="日常能(设备标准产出量)"></el-table-column>
      <el-table-column align="left" prop="UnitName" label="单位"></el-table-column>
      <el-table-column align="left" prop="EquipmentStatusName" label="状态"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/production/teProcessUnit").default,
      trendShow: true,
      params: {
        TransportName: "",
        TransportNo: "",
        Status: null,
      },
      subList:[]
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onRowClick(row){
      this.api.info(row.ProcessUnitId).then((res) => {
        this.subList = res.Data.DetailDtos;
      });
    },
  },
};
</script>
<style scoped>
.facility{
  margin: 20px 0 10 0px !important
}
</style>